const translationsBS = {
  "-- Select option --": "-- Odaberite opciju --",
  "About Our Speaker": "O govorniku",
  "add-google-calendar": "Dodaj u google kalendar",
  agenda: "Dnevni red",
  All: "Svi",
  "All categories": "Sve kategorije",
  "All locations": "Sve lokacije",
  "and-book": "and book",
  "back-to-events": "Nazad na dešavanja",
  "BK Event": "BK događaj",
  "book-only": "Samo sa rezervacijom",
  Centre: "Centar",
  Close: "Zatvori",
  Conference: "Konferencija",
  "Contact Email": "Kontakt email",
  "Copied event address to clipboard ...":
    "Copied event address to clipboard ...",
  "Could not retrieve event due to an error":
    "Zbog greške nismo mogli povratit događaj",
  Course: "Kurs",
  day: "Dan",
  days: "Dani",
  description: "Opis",
  "enter-search": "Unesite pojam ...",
  event_plural: "Događaji",
  event: "Događaj",
  "go-to-page": "Idite na stranicu",
  "Group session": "Grupna sesija",
  hours: "Sati",
  "Import on Google Calendar": "Ubaci u google kalendar",
  "Join Zoom meeting": "Pridruži se Zoom sastanku",
  Lecture: "Predavanje",
  Meditation: "Meditacija",
  minutes: "minute",
  Miscellaneous: "Razno",
  month: "Mjesec",
  month_January: "Januar",
  month_February: "Februar",
  month_March: "Mart",
  month_April: "April",
  month_May: "Maj",
  month_June: "Juni",
  month_July: "Juli",
  month_August: "Avgust",
  month_September: "Septembar",
  month_October: "Oktobar",
  month_November: "Novembar",
  month_December: "Decembar",
  "More details": "Više detalja",
  "More informations about this event on": "Više informacija o ovom događaju",
  next: "Slijedeće",
  "No events found": "Nije pronađen događaj ...",
  "no event id": "Nema ID-a događaja. Molimo dodajte ID događaja (?eventId=<id>) u URL.",
  of: "od",
  "online_state_In Person": "Lično",
  online_state_Mixed: "Preko interneta i lično",
  online_state_None: "Sva dešavanja",
  online_state_Online: "Sva dešavanja",
  "Online activity": "Aktivnost preko interneta",
  "Online State": "Internet status",
  "Open webcast URL": "Gledaj uživo",
  "other-sessions": "Ostale sesije",
  page: "Stranica",
  "Panel discussion": "Panel diskusija",
  "Power and protection": "Snaga i zaštita",
  previous: "Prethodno",
  Private: "Privatno",
  "read-more": "Pročitaj više",
  Retreat: "Retreat",
  search: "Pretraga",
  seconds: "sekunde",
  Seminar: "seminar",
  "Share on Facebook": "Podijeli na Facebook-u",
  "Share on Twitter": "Podijeli na Twitter-u",
  "Share via Email": "Podijeli emailom",
  show: "Pokaži",
  "Show required fields": "Prikaži obavezna polja",
  "Show less": "Pokaži manje",
  "Show more": "Pokaži više",
  "Similar Events": "Slični događaji",
  "Special event": "SPosebni događaji",
  Table: "Tabela",
  to: "to",
  "To get started, edit <1>src/App.js</1> and save to reload.":
    "To get started, edit <1>src/App.js</1> and save to reload.",
  today: "Danas",
  Training: "Trening",
  "upcoming-dates": "Nadolazeći datumi",
  week: "Sedmica",
  weekday_FR: "PETAK",
  weekday_MO: "PON",
  weekday_SA: "SUBOTA",
  weekday_SU: "NEDJELJA",
  weekday_TH: "ČETVRTAK",
  weekday_TU: "UTORAK",
  weekday_WE: "SRIJEDA",
  Workshop: "Radionica",
  "Your time": "Vaše vrijeme",
  "There are no more seats available for this event!":
    "Više nema prostora za ovaj događaj. Molimo vas da probate rezervisati drugi datum.",
};

module.exports = {
  translationsBS,
};
